
  (function () {
  const run = () => {
    const widget = document.querySelector("delivery-promise-container");

    if (!widget || !widget.shadowRoot) return;

    const root = widget.shadowRoot;
    const parent = root.querySelector(".concise-content");
    const deliveryEl = root.querySelector("#ddp-date-fastest-delivery");
    const zipSection = root.querySelector(".zipcode-section");

    if (!parent || !deliveryEl || !zipSection) return;

    //  1. Update text structure (only once)
    if (!deliveryEl.querySelector(".stdde")) {
      const originalText = deliveryEl.innerText.trim();
      deliveryEl.innerHTML = `Get it by <span class="stdde">${originalText} </span>`;
    }

    //  2. Insert "with FREE Shipping to" (only once)
    if (!root.querySelector(".wfst")) {
      const span = document.createElement("span");
      span.className = "wfst";
      span.innerHTML = '<span class="awith">with</span><br> <span class="frshp">FREE Shipping </span><span class="ato">to </span>';
      parent.insertBefore(span, zipSection);
    }

    //  3. Inject CSS (only once)
    if (!root.querySelector("#custom-delivery-style")) {
      const style = document.createElement("style");
      style.id = "custom-delivery-style";
      style.textContent = `
        span#ddp-date-fastest-delivery {
          font-weight: 400 !important;
        }

        span.stdde {
          color: #047602 !important;
          font-weight: bold !important;
        }

        #ddp-date-fastest-delivery + span {
          font-weight: bold !important;
          color: #047602 !important;
        }

        .wfst {
          font-weight: bold !important;
        }

        span.awith,
        span.ato {
          font-weight: 400 !important;
        }
        .concise-container{
            text-align: center;
          }
          .ddp-zipcode {
            font-weight: bold !important;
            color: #01B2E2 !important;
        }
        .concise-content {
            letter-spacing: 0;
            line-height: 1;
        }
        .concise-content span {
        font-family: Work Sans, sans-serif !important;
        }
        span.geopin-container {
            display: none !important;
        }
        span.frshp {
            text-transform: uppercase;
            color: #525252 !important;
            font-weight:bold;
        }
         @media (min-width: 1100px) {
          .concise-content span {
            font-size:20px !important;
          }
         }
        @media (max-width: 600px) {
        .concise-content {
            letter-spacing: 0;
        }
         .concise-content span {
            font-size:13px !important;
          }
          .concise-container {
              text-align: center;
              margin: 0 auto;
          }
        }
        @media (max-width: 395px) {
          .concise-content span {
            font-size:12px !important;
          }
        }
      `;
      root.appendChild(style);
    }
  };

  const interval = setInterval(() => {
    run();
  }, 500);

  const observer = new MutationObserver(() => {
    run();
  });

  const widgetCheck = setInterval(() => {
    const widget = document.querySelector("delivery-promise-container");
    if (widget && widget.shadowRoot) {
      observer.observe(widget.shadowRoot, { childList: true, subtree: true });
      clearInterval(widgetCheck);
    }
  }, 500);

})();




/* prodcut gallery popup code strat */

                  document.addEventListener('DOMContentLoaded', () => {
                    // move popup to body (safer z-index)
                    const popup = document.querySelector('.real-video-popup');
                    if (popup) document.body.appendChild(popup);

                    const popupBox = popup?.querySelector('.real-video-add');
                    const closeBtn = popup?.querySelector('.close-button');
                    let currentVideoEl = null;

                    // click each thumbnail/card
                    document.querySelectorAll('.real-result-image').forEach((card) => {
                      card.addEventListener('click', (e) => {
                        e.preventDefault();
                        const videoHolder = card.querySelector('.video-tag');
                        if (!videoHolder || !popupBox) return;

                        // if already playing this one -> close it
                        if (card.classList.contains('played')) {
                          popup.classList.remove('open');
                          if (currentVideoEl) {
                            currentVideoEl.pause();
                            currentVideoEl.currentTime = 0;
                          }
                          popupBox.innerHTML = '';
                          currentVideoEl = null;
                          card.classList.remove('played');
                          return;
                        }

                        // stop previous
                        if (currentVideoEl) {
                          currentVideoEl.pause();
                          currentVideoEl.currentTime = 0;
                        }
                        document
                          .querySelectorAll('.real-result-image.played')
                          .forEach((el) => el.classList.remove('played'));

                        // inject this video's HTML into popup
                        popupBox.innerHTML = videoHolder.innerHTML;

                        // open + play
                        popup.classList.add('open');
                        currentVideoEl = popupBox.querySelector('video');
                        if (currentVideoEl) currentVideoEl.play();

                        // mark this card as active
                        card.classList.add('played');
                      });
                    });

                    // close popup
                    closeBtn?.addEventListener('click', () => {
                      popup.classList.remove('open');

                      if (currentVideoEl) {
                        currentVideoEl.pause();
                        currentVideoEl.currentTime = 0;
                        currentVideoEl = null;
                      }

                      popupBox.innerHTML = '';
                      document
                        .querySelectorAll('.real-result-image.played')
                        .forEach((el) => el.classList.remove('played'));
                    });
                  });

/* prodcut gallery popup code end */